import { h } from 'preact';
import 'jquery-file-download';
import constants from '../../constants';
import util, { toLogIn } from '../../util';
import { useEffect, useMemo, useState } from "preact/hooks";
import Renderer from "../../canvas/renderer";
import designService from "../../service/designService";
import $ from "jquery";
import CheckIcon from "../icon/CheckIcon";
import axios from 'axios';
import { ExclamationCircleTwoTone } from '@ant-design/icons';

function getPromoData(designSize) {
  let thumb = "https://musthavemenus.com/imageservice/images/img/13/timber/print-business-cards.jpg";
  let text = "Get professional prints delivered to your door.";

  if (util.isMenu(designSize) || util.isHalfPageMenu(designSize) || util.isTableTentInsert(designSize)) {
    thumb = "https://musthavemenus.com/imageservice/images/img/13/timber/laminated-dine-ins.jpg";
    text = "Get easy-to-clean laminated prints delivered to your door.";
  } else if (util.isTakeout(designSize)) {
    thumb = "https://musthavemenus.com/imageservice/images/img/13/timber/takeouts.jpg";
    text = "Get pre-folded takeouts delivered to your door.";
  } else if (util.isFlyer(designSize)) {
    thumb = "https://musthavemenus.com/imageservice/images/img/13/timber/flyers.jpg";
  }

  return { thumb, text };
}

export default function DownloadOptions({
  designId, isLogged, locationId, isSocialDesign, isLogo, designSize, isDigitalMenuBoard, isCustomSize, designUnit, hasPdfPermission, memberCountry,
  setIsSaved, setIsSaving, goToPrint, setActiveMember,
  setDownloadLoading, withPrintCta, free, isTemplateLink, hasVideo, hasAnimation, pageNumError, isMobile
}) {
  const [downloadType, setDownloadType] = useState(hasPdfPermission ? 'pdf' : 'jpg');
  const [downloadTypeTitle, setDownloadTypeTitle] = useState();
  const [videoDuration, setVideoDuration] = useState(30);
  const [isVideoType, setIsVideoType] = useState((designUnit === 'px' && !isLogo) || isDigitalMenuBoard);

  const [selectedPages, setSelectedPages] = useState([]);

  const numberOfPages = util.getNumberOfPages();

  const updateTimestamp = useMemo(() => Date.now(), []);

  useEffect(() => {
    if (numberOfPages > 0) {
      setSelectedPages(Array.from({ length: numberOfPages }, (_, i) => i + 1));
    }
  }, [numberOfPages]);

  useEffect(() => {
    $('.download-dropdown').on('click', function (event) {
      if (!$(event.target).closest('.dropdown-select-pages').length &&
        !$(event.target).closest('.selected-select-pages').length) {
        $(".dropdown-menu.dropdown-select-pages").removeClass("show");
      }
    });
  }, []);

  useEffect(() => {
    let setDefault = true;
    if ((isSocialDesign || isLogo || (isCustomSize && designUnit === 'px'))) {
      setDownloadType('jpg');
      setDefault = false;
    }

    if ((hasVideo || hasAnimation) && isVideoType) {
      setDownloadType('mp4');
      setDefault = false;
    }

    if (setDefault) setDownloadType(hasPdfPermission ? 'pdf' : 'jpg');

  }, [isSocialDesign, isLogo, isCustomSize, designUnit, hasVideo, hasAnimation, isVideoType]);

  useEffect(() => {
    setIsVideoType((designUnit === 'px' && !isLogo) || isDigitalMenuBoard);
  }, [designUnit, isLogo, isDigitalMenuBoard])

  useEffect(() => {
    window.App = window.App || {};
    window.App.downloadPdf = directPdfDownload;
  }, []);

  useEffect(() => {
    setDownloadTypeTitle($('.drp-dnd .selected label').text());
  }, [downloadType]);

  function selectDownloadType(type) {
    setDownloadType(type);

    if (!hasPdfPermission && !free && type !== 'jpg' || (!hasPdfPermission && type === 'mp4')) {
      util.hideDropdown();
      window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: setActiveMember });
    }

    if (type === 'mp4') {
      setVideoDuration(util.getVideoLongestDuration());
    }

    $(".download-dropdown .dropdown-menu").removeClass("show");
    // setDownloadTypeTitle($('.drp-dnd .selected label').text());
  }

  function validateDownload() {
    if (pageNumError && isVideoType) return;

    switch (downloadType) {
      case 'pdf':
        downloadAsPdf();
        break;
      case 'pdf-bleed':
        downloadAsBleedPdf();
        break;
      case 'png':
        downloadPng();
        break;
      case 'jpg':
        downloadJpg();
        break;
      case 'mp4':
        downloadMp4();
        break;
      case 'webm':
        downloadWebM();
        break;
    }
  }

  function validatePermission() {
    if (!isLogged) {
      toLogIn()
      return false;
    }
    if (!hasPdfPermission && !free || (!hasPdfPermission && downloadType === 'mp4')) {
      util.hideDropdown();
      window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: setActiveMember });
      return false;
    }
    return true;
  }

  function downloadAsPdf() {
    if (!validatePermission()) return;
    download(false)
  }

  function downloadAsBleedPdf() {
    if (!validatePermission()) return;
    download(true);
  }

  function downloadPng() {
    if (!validatePermission()) return;
    download(false, 'png');
  }

  function downloadJpg() {
    download(false, 'jpg');
  }

  function downloadMp4() {
    if (!validatePermission()) return;
    download(false, 'mp4');
  }

  function downloadWebM() {
    if (!validatePermission()) return;
    download(false, 'webm');
  }

  function directPdfDownload() {
    switch (downloadType) {
      case 'pdf':
        download(false);
        break;
      case 'pdf-bleed':
        download(true);
        break;
      case 'png':
        download(false, 'png');
        break;
      case 'jpg':
        download(false, 'png');
        break;
    }

    //window.mhm.Payment.ui.close()
  }

  function download(bleed, type = 'pdf') {
    setIsSaved(false);
    setIsSaving(true);

    Renderer.fixLayeringIssue();

    // workaround since phone downloads weren't working
    let userAgent = (navigator.userAgent || navigator.vendor || window.opera).toLowerCase();
    var isIos = /ip(ad|hone|od)/.test(userAgent);
    var isAndroid = userAgent.indexOf('android') !== -1;
    // open window now to prevent pop-up from being blocked
    if (isIos || isAndroid) {
      var downloadWindow = window.open();
    }

    setDownloadLoading(true);
    designService.updateDesignHtml({
      id: designId,
      html: Renderer.getPagesContent(),
      hasVideo: hasVideo
    }).then(() => {
      setIsSaved(true);
      setIsSaving(false);

      designService.registerDownload(designId).then(() => {
        const selectedPagesString = selectedPages.join(',');

        let fileUrl = constants.RENDERER_DOMAIN +
          '/design/download/' + designId + '.' + type +
          '?bleed=' + bleed +
          '&pages=' + selectedPagesString +
          '&update=' + Date.now()

        if (type === 'mp4' || type === 'webm') {
          fileUrl = constants.VIDEO_RENDERER_DOMAIN + '/design/download/' + designId + '.' + type + '?bleed=' + bleed + '&update=' + Date.now() + '&duration=' + videoDuration;
        }

        if (isIos || isAndroid) {
          try {
            downloadWindow.location = fileUrl;
            downloadWindow.document.title = "Initiating file download...";
            window.focus();
            ga('send', 'event', 'download', 'lite', type);
          } catch {
            console.log(err);
          }
          setDownloadLoading(false);
          checkPostDownload();
        } else {
          axios.get(fileUrl, { responseType: 'blob' })
            .then(resp => {
              const url = window.URL.createObjectURL(resp.data);
              const a = document.createElement('a');
              a.style.display = 'none';
              a.href = url;
              a.download = resp.headers.filename;
              document.body.appendChild(a);
              a.click();
              window.URL.revokeObjectURL(url);

              ga('send', 'event', 'download', 'lite', type);
              setDownloadLoading(false);
              checkPostDownload();
            }).catch((e) => {
              console.log(e);
              setDownloadLoading(false);
              checkPostDownload();
            });

          // jQuery.fileDownload(fileUrl).done(resp => {
          //   ga('send', 'event', 'download', 'lite', type);
          //   setDownloadLoading(false);
          //   checkPostDownload();
          // }).fail(() => {
          //   setDownloadLoading(false);
          //   checkPostDownload();
          // })
        }
      });
    });
  }

  function checkPostDownload() {
    if ((!memberCountry || util.isUSCountry(memberCountry)) && util.isMenu(designSize) && !util.isA4(designSize)) {
      $('body').click();
    }
  }

  function changeVideoDuration(ev) {
    setVideoDuration(ev.target.value);
  }

  const size = util.sizes.filter(size => size.key === designSize)[0];
  const isA4 = size && size.key.indexOf('a4') > -1;
  const { thumb, text } = getPromoData(designSize);

  function togglePageSelection(pageNumber) {
    setSelectedPages(prevPages => {
      if (prevPages.includes(pageNumber)) {
        return prevPages.filter(page => page !== pageNumber);
      } else {
        return [...prevPages, pageNumber];
      }
    });
  }

  function toggleSelectAllPages() {
    if (selectedPages.length === numberOfPages) {
      setSelectedPages([]);
    } else {
      setSelectedPages(Array.from({ length: numberOfPages }, (_, i) => i + 1));
    }
  }

  function finalizePagesSelection() {
    $(".dropdown-menu.dropdown-select-pages").removeClass("show");
  }

  function getSelectedPagesText() {
    if (selectedPages.length === 0) {
      return 'Select Pages';
    } else if (selectedPages.length === numberOfPages) {
      return `All Pages (1-${numberOfPages})`;
    } else {
      return selectedPages
        .sort((a, b) => a - b)
        .map(page => `Page ${page}`)
        .join(', ');
    }
  }

  return (
    <div className="download-dropdown">
      <h3>Download</h3>

      <div className="dropdown" style="position: relative;">
        <label>File Type</label>
        <div className="dropdown-toggle selected-download-type" data-is-nested="true">
          {downloadTypeTitle}
          <img src="/imageservice/images/img/13/pay-modal/Pro2.svg" alt=""
            className={
              ((!hasPdfPermission && !free) ||
                (!hasPdfPermission && downloadType === 'mp4')) &&
                downloadType !== 'jpg'
                ? 'star-icon'
                : 'hidden'} />
        </div>

        <div className={`dropdown-menu dropdown-sticky ${isMobile ? "top": ""}`} data-close="no">
          <ul className="drp-dnd">
            {/* {withPrintCta && <li className={(isSocialDesign || isLogo || isA4 || isDigitalMenuBoard || isCustomSize ? 'hidden' : '')}>
              <div style="padding: .5rem 1.5rem;">
                <div style="display: inline;">
                  <img src={thumb} style="width:70px" alt={''} />
                </div>

                <div style="display: inline-block; margin-left: 20px; margin-top: 10px; position: absolute; font-size: 14px; line-height: 17px">
                  {text}
                  <br />
                  <a className="order-print-promo" style="width: auto; padding: 0; margin-top: 8px" onClick={goToPrint}>Order Prints &gt;</a>
                </div>
              </div>
            </li>} */}

            {/* {hasVideo && <li>
              <a onClick={() => selectDownloadType('mp4')} className={downloadType === 'mp4-basic' ? 'selected' : ''}>
                <div className={!hasPdfPermission && !free ? 'hidden' : 'check pull-right'}>
                  <CheckIcon />
                </div>
                <div className={hasPdfPermission || free ? 'hidden' : 'pull-right'}>
                  <img src="/imageservice/images/img/13/pay-modal/Pro2.svg" className="star-icon" alt="" />
                </div>
                <label>Basic Video</label><br />
                <span>720 x 405</span>
              </a>
            </li>} */}

            {((hasVideo|| hasAnimation) && isVideoType) && <li>
              <a onClick={() => selectDownloadType('mp4')} className={downloadType === 'mp4' ? 'selected' : ''}>
                <div className={!hasPdfPermission ? 'hidden' : 'check pull-right'}>
                  <CheckIcon />
                </div>
                <div className={hasPdfPermission ? 'hidden' : 'pull-right'}>
                  <img src="/imageservice/images/img/13/pay-modal/Pro2.svg" className="star-icon" alt="" />
                </div>
                <label>HD Video</label><br />
                <span>1920 x 1080 • High resolution video for <br />displays and social media</span>
              </a>
            </li>}

            <li className={isSocialDesign || isLogo || (isCustomSize && designUnit === 'px') ? 'hidden' : ''}>
              <a onClick={() => selectDownloadType('pdf')} className={downloadType === 'pdf' ? 'selected' : ''}>
                <div className={!hasPdfPermission && !free ? 'hidden' : 'check pull-right'}>
                  <CheckIcon />
                </div>
                <div className={hasPdfPermission || free ? 'hidden' : 'pull-right'}><img src="/imageservice/images/img/13/pay-modal/Pro2.svg" className="star-icon" alt="" /></div>

                <label>Standard PDF</label><br />
                <span>High quality for in-house printing</span>
              </a>
            </li>

            {<li className={isSocialDesign || isLogo || isDigitalMenuBoard || (isCustomSize && designUnit === 'px') ? 'hidden' : ''}>
              <a onClick={() => selectDownloadType('pdf-bleed')} className={downloadType === 'pdf-bleed' ? 'selected' : ''}>
                <div className={!hasPdfPermission && !free ? 'hidden' : 'check pull-right'}>
                  <CheckIcon />
                </div>
                <div className={hasPdfPermission || free ? 'hidden' : 'pull-right'}><img src="/imageservice/images/img/13/pay-modal/Pro2.svg" className="star-icon" alt="" /></div>

                <label>Pro Print PDF</label><br />
                <span>High quality with bleed</span>
              </a>
            </li>}

            <li>
              <a onClick={() => selectDownloadType('png')} className={downloadType === 'png' ? 'selected' : ''}>
                <div className={!hasPdfPermission && !free ? 'hidden' : 'check pull-right'}>
                  <CheckIcon />
                </div>
                <div className={hasPdfPermission || free ? 'hidden' : 'pull-right'}>
                  <img src="/imageservice/images/img/13/pay-modal/Pro2.svg" className="star-icon" alt="" />
                </div>
                <label>Premium Web Image</label><br />
                <span>High quality PNG image for web</span>
              </a>
            </li>

            <li>
              <a onClick={() => selectDownloadType('jpg')} className={downloadType === 'jpg' ? 'selected' : ''}>
                <div className="check pull-right">
                  <CheckIcon />
                </div>
                <label>Basic Image <span className={!hasPdfPermission && !free ? 'free-label' : 'hidden'}>Print</span></label><br />
                <span>Basic quality JPG image</span>
              </a>
            </li>
          </ul>
        </div>

        {hasPdfPermission && downloadType === 'mp4' &&
          <a className="duration-slider">
            <label>Duration</label><br />
            <div className="slider-wrap">
              <div className="toolbar-wrap">
                <input className="slider" type="range" min="0" max="30" step="1" value={videoDuration} onChange={changeVideoDuration} />
              </div>
              <span>{videoDuration}s</span>
            </div>
          </a>
        }

        {(hasVideo || hasAnimation) && downloadType !== 'mp4' &&
          <div className="warning">
            {`Videos, audio, and animations won't play when downloaded as this file type.${isVideoType ? ' Try downloading as a video.' : ''}`}
          </div>
        }

        {pageNumError && isVideoType && <div className="warning pages-warning">
          <ExclamationCircleTwoTone twoToneColor={'#fcac14'} /><span>Video designs can only be 3 pages to download. Please delete additional pages.</span>
        </div>}
      </div>

      {downloadType !== 'mp4' && numberOfPages > 1 &&
        <div className="dropdown" style="position: relative;">
          <label>Select Pages</label>
          <div className="dropdown-toggle selected-select-pages" data-is-nested="true">
            {getSelectedPagesText()}
          </div>

          <div className={`dropdown-menu dropdown-sticky dropdown-select-pages ${isMobile ? "top": ""}`} data-close="no">
            <ul className="drp-dnd">
              <li>
                <label>
                  <input type="checkbox" value="all" onChange={toggleSelectAllPages} checked={selectedPages.length === numberOfPages} />
                  <span>All pages (1-{numberOfPages})</span>
                </label>
              </li>

              {
                [...Array(numberOfPages)].map((_, i) => (
                  <li key={i}>
                    <label>
                      <input
                        type="checkbox"
                        value={i + 1}
                        onChange={() => togglePageSelection(i + 1)}
                        checked={selectedPages.includes(i + 1)}
                      />
                      <img
                        src={`${constants.RENDERER_DOMAIN}/design/thumbnail/${designId}?height=300&page=${i + 1}&update=${updateTimestamp}`}
                        alt={`Page ${i + 1}`}
                      />
                      <span>Page {i + 1}</span>
                    </label>
                  </li>
                ))
              }
            </ul>

            <div className="dropdown-footer">
              <a onClick={finalizePagesSelection} className={`btn primary text-center ${selectedPages.length === 0 ? 'disabled' : ''}`}>
                Done
              </a>
            </div>
          </div>
        </div>
      }

      <a onClick={validateDownload} className={`btn primary text-center ${pageNumError && isVideoType ? 'disabled' : ''}`}>
        <span className={!hasPdfPermission && !free && downloadType === 'jpg' ? '' : 'hidden'}>Print</span> Download
      </a>
    </div>
  )
}
